import { html, render } from "lit-html";
import { when } from "lit-html/directives/when.js";
import { dealTemplate, formatDealDateRange } from "./get-description-template";
import { translate } from "@escapio/shared/l10n/translate";
import {
	isAtLeast,
	SIZE_TABLET,
	unwatch as unwatchScreenSize,
	watch as watchScreenSize,
} from "@escapio/portal/dom/screen";
import {
	ARTICLE_DEAL_MOBILE,
	ARTICLE_DEAL_TABLET,
} from "@escapio/shared/components/picture-sizes";
import "@escapio/shared/components/Picture";
import "@escapio/portal/components/tracker/ImpressionInteractionTracker";

export const EVENT_ACTION_PREFIX = "Deal ohne Hotel";

export const getMobileDealStageTemplate = deal =>
	html`<a
			class="hotel-list-item-mobile__picture-link"
			href="${deal.url}"
			target="_blank"
			rel="noreferrer noopener"
		>
			<div class="hotel-list-item-mobile__picture">
				<esc-picture
					sizes-key="${ARTICLE_DEAL_MOBILE}"
					filename="${deal.media}"
					alt="${deal.headline}"
				></esc-picture>
			</div>
		</a>
		<a href="${deal.url}" target="_blank" rel="noreferrer noopener">
			<div
				class="hotel-list-item-mobile__description hotel-list-item-mobile__name-container"
			>
				<span class="ellipsis">${deal.headline}</span>
				<span class="fa fa-angle-right fa--space-before"></span>
			</div>
		</a>`;

customElements.define(
	"esc-article-deal",
	class extends HTMLElement {
		connectedCallback() {
			this.render();
			watchScreenSize(this, this.render.bind(this));
		}

		disconnectedCallback() {
			unwatchScreenSize(this);
		}

		render() {
			const template = html`<esc-impression-interaction-tracker
				content-name="${this.eventCategory} - ${EVENT_ACTION_PREFIX}"
				content-piece="${this.deal.id} | ${this.deal
					.headline} - ${formatDealDateRange(this.deal)}"
				content-target="${this.deal.url}"
			>
				${when(
					isAtLeast(SIZE_TABLET),
					this.renderTablet.bind(this),
					this.renderMobile.bind(this),
				)}
			</esc-impression-interaction-tracker>`;
			render(template, this, { host: this });
		}

		renderMobile() {
			return [getMobileDealStageTemplate(this.deal), this.dealTemplate];
		}

		renderTablet() {
			return html`<div class="hotel-list-item-desktop__container">
				<a
					class="hotel-list-item-desktop__picture"
					href=${this.deal.url}
					target="_blank"
					rel="noreferrer noopener"
				>
					<esc-picture
						filename="${this.deal.media}"
						alt="${this.deal.headline}"
						sizes-key="${ARTICLE_DEAL_TABLET}"
					></esc-picture>
				</a>

				<div class="deal-list-item-desktop__data">
					<a
						class="hotel-list-item-desktop__header"
						href=${this.deal.url}
						target="_blank"
						rel="noreferrer noopener"
					>
						<div class="hotel-list-item-desktop__description">
							<span
								class="hotel-list-item-desktop__name-container hotel-list-item-desktop__hotel-name ellipsis"
							>
								${this.deal.headline}
							</span>
						</div>
					</a>
					${this.dealTemplate}
				</div>
			</div>`;
		}

		get dealTemplate() {
			return dealTemplate(translate("deals_list_cta_label_article"), this.deal);
		}

		get eventCategory() {
			return this.getAttribute("event-category");
		}
	},
);
